import { UiTab } from '@/models/ui/UiTab'

export class UiTabs {
    public tabs:Array<UiTab>
    public selected:string
    constructor({tabs = [] as Array<UiTab>, selected = "MissionMenu-0"} = {}) {
        this.tabs = tabs.map(t => new UiTab(t))
        this.selected = selected   
    }
}